import { getPasswordValidity } from '~vue/helpers/check-password-validity';

const template = require('./password_requirement.html.slim');

angular.module('wbComponents').directive('passwordRequirement', [() => ({
  scope: false,
  restrict: 'E',
  templateUrl: template,

  link($scope, $el, $attrs) {
    let calcPlacement;
    let zxcvbn = null;
    const { ref } = $attrs;
    const tooltip = $el.children().children('.tooltip');
    const dialogBox = $("[name='passwordDialog'] .dialog-box");
    const errorMsg = $("[name='passwordDialog'] .error");
    const successMsg = $("[name='passwordDialog'] .success");
    const { email } = window.currentUser;

    (calcPlacement = () => {
      let calcHeight;
      if (window.innerWidth <= 768) {
        const btnOffset = $("[pwr-ref='" + ref + "'][type='submit']").offset();
        calcHeight = ((btnOffset ? btnOffset.top : 0) - $el.offset().top) + errorMsg.height() + successMsg.height() + 55; //baseline * 2.5
        return tooltip.css({ 'top': calcHeight + 'px', 'left': 0 });
      }
      const pw = $("[pwr-ref='" + ref + "'][name='password']");
      const pwOffset = pw.offset();
      calcHeight = ((pwOffset ? pwOffset.top : 0) - (tooltip.height() / 2)) + (pw.height() / 2);
      const calcWidth = (pwOffset ? pwOffset.left : 0) + pw.width() + 44; //baseline * 2
      return tooltip.css({ 'top': calcHeight + 'px', 'left': calcWidth + 'px' });
    }
    )();

    $(window).on('resize', _.debounce(() => calcPlacement(), 100));

    $("[pwr-ref='" + ref + "'][name='password']").focus(() => {
      calcPlacement();
      $scope.pwFocus = true;
      if (window.innerWidth <= 768) {
        dialogBox.css({ 'height': dialogBox.outerHeight() + tooltip.outerHeight() + 11 + 'px' });
      }
      require(["zxcvbn/dist/zxcvbn"], req => zxcvbn = req);
      return $scope.$apply();
    });

    $("[pwr-ref='" + ref + "'][name='password']").focusout(() => {
      $scope.pwFocus = false;
      if (window.innerWidth <= 768) {
        dialogBox.removeAttr('style');
      }
      return $scope.$apply();
    });

    return $scope.$watch($attrs.passwordInput, (newPassword) => {
      $scope.requirements = {};
      $scope.passwordStrength = {};

      if (!newPassword) {
        $scope.inputStrength = '';
        return;
      }

      const { email: noEmail, firstName: noFirstname, lastName: noLastname } = getPasswordValidity(
        newPassword,
        email,
        window.currentUser.firstName,
        window.currentUser.lastName,
      );

      if (newPassword.match(/^(?=.*[A-Z])/)) { // uppercase
        $scope.requirements['upper'] = true;
      }

      if (newPassword.match(/^(?=.*[a-z])/)) { // lowercase
        $scope.requirements['lower'] = true;
      }

      if ((newPassword.length >= 8) && (newPassword.length < 256)) { // length
        $scope.requirements['length'] = true;
      }

      if (newPassword.match(/^(.*[0-9])/)) { // numeric
        $scope.requirements['numeric'] = true;
      }

      if (/\W|_/g.test(newPassword)) { // symbol
        $scope.requirements['symbol'] = true;
      }

      if (noEmail) { // No email in password
        $scope.requirements['noEmail'] = true;
      }

      if (noFirstname) { // No firstname in password
        $scope.requirements['noFirstname'] = true;
      }

      if (noLastname) { // No lastname in password
        $scope.requirements['noLastname'] = true;
      }

      // =================== Checks requirements =================== #
      if ($scope.requirements['upper'] && $scope.requirements['lower']
        && $scope.requirements['length'] && $scope.requirements['numeric']
        && $scope.requirements['symbol'] && $scope.requirements['noEmail']
        && $scope.requirements['noFirstname'] && $scope.requirements['noLastname']) {
        $scope.passwordStrength.accepted = true;
      }

      // zxcvbn gem - checks password strength
      // Can accept a custom list to check against after the password
      if (zxcvbn == null) { return; }
      const strengthCalc = zxcvbn(newPassword);

      if (strengthCalc.score === 4) {
        $scope.passwordStrength.step5 = true;
        $scope.inputStrength = 'Very Strong!';
        return $scope.inputStrength;
      }
      if (strengthCalc.score === 3) {
        $scope.passwordStrength.step4 = true;
        $scope.inputStrength = 'Strong';
        return $scope.inputStrength;
      }
      if (strengthCalc.score === 2) {
        $scope.passwordStrength.step3 = true;
        $scope.inputStrength = 'Good';
        return $scope.inputStrength;
      }
      if (strengthCalc.score === 1) {
        $scope.passwordStrength.step2 = true;
        $scope.inputStrength = 'Okay';
        return $scope.inputStrength;
      }
      if (strengthCalc.score === 0) {
        $scope.passwordStrength.step1 = true;
        $scope.inputStrength = 'Weak';
        return $scope.inputStrength;
      }
    });
  }
})
]);
